import { motion } from "framer-motion";
import { useEffect } from "react";
import photoGalleryJSON from "./photos.json";

import {
  Carousel,
  CarouselItem,
  Container,
  Row,
  Image,
  Col,
} from "react-bootstrap";

interface PhotoSet {
  title: string;
  images: string[];
}

export const PhotoGallery = () => {
  useEffect(() => {
    document.title = "Mohamad Tarabin - Photo Gallery";
  }, []);

  const photosList: PhotoSet[] = photoGalleryJSON.photos;

  const isMobile = window.innerWidth < 768;

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true }}
      >
        <Container
        fluid
        style={{
          marginBottom: "100px",
          marginTop: "50px",
        }}
        >

          <h1
            style={{
              marginBottom: "40px",
              textAlign: "center",
            }}
          >
            Photo Gallery
          </h1>

          <Row style={{justifyContent: "center", gap: "50px"}}>
          {photosList.map((photoSet) => (
            <Col 
            key={photoSet.title}
            xs={12}
            lg={5}
            style={{ marginBottom: "70px", }}>

              <h3>{photoSet.title}</h3>
              <Carousel>
                {photoSet.images.map((image) => (
                  <CarouselItem
                    style={
                      isMobile
                        ? {
                            width: "100%",
                            height: "60vh",
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                          }
                        : {
                            width: "100%",
                            height: "70vh",
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            // position: "absolute",
                          }
                    }
                  >
                    {isMobile ? (
                      <Image src={image} fluid />
                    ) : (
                      <Image
                        className="mx-auto d-block"
                        src={image}
                        style={{
                          height: "100%",
                        }}
                      />
                    )}
                  </CarouselItem>
                ))}
              </Carousel>
            </Col>
          ))}
                      </Row>



        </Container>
      </motion.div>
    </>
  );
};
